import { render, staticRenderFns } from "./AbsoluteContradictions.vue?vue&type=template&id=d128f89a&scoped=true"
import script from "./AbsoluteContradictions.vue?vue&type=script&lang=js"
export * from "./AbsoluteContradictions.vue?vue&type=script&lang=js"
import style0 from "./AbsoluteContradictions.vue?vue&type=style&index=0&id=d128f89a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d128f89a",
  null
  
)

export default component.exports